import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import RetroButton from '../ui/RetroButton';

const Header = () => {
  const location = useLocation();
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/e80eb4a41c317bb5346a84936eb4292e.png";

  return (
    <header className="border-b-4 border-retro-brown bg-retro-cream sticky top-0 z-50 h-20 flex items-center">
      <div className="max-w-7xl mx-auto px-6 w-full flex justify-between items-center relative">
        <div className="flex items-center relative z-[60]">
          <Link to="/" className="block relative h-12 w-48 md:w-64">
            <img 
              src={logoUrl} 
              alt="Mailbox Flyers" 
              className="absolute top-4 md:top-6 left-0 h-24 md:h-32 w-auto object-contain drop-shadow-[4px_4px_0_rgba(58,44,39,0.2)] hover:scale-105 transition-transform duration-300" 
            />
          </Link>
        </div>

        <nav className="hidden lg:flex items-center gap-10 font-body font-bold text-lg mr-8">
          <Link
            to="/"
            className={`transition-colors underline-offset-4 hover:underline ${location.pathname === '/' ? 'text-retro-teal underline' : 'hover:text-retro-teal'}`}
          >
            Home
          </Link>
          <Link
            to="/how-it-works"
            className={`transition-colors underline-offset-4 hover:underline ${location.pathname === '/how-it-works' ? 'text-retro-teal underline' : 'hover:text-retro-teal'}`}
          >
            How It Works
          </Link>
        </nav>

        <div className="flex items-center gap-4">
          <Link to="/find-your-city">
            <RetroButton
              variant="primary"
              className="!py-2 !px-6 !text-base !shadow-retro-sm !bg-emerald-500 !text-white !border-slate-900 active:!translate-y-[2px] active:!translate-x-[2px]"
            >
              Check Availability
            </RetroButton>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;